let environment = "Prod-SSO";
if (environment.lastIndexOf("%#") !== -1) {
  environment = "Prod-SSO";
}

const PrdSsoEnvKey = "Prod-SSO";

export const BoardIds = {
  Client_Card: environment === PrdSsoEnvKey ? "3488" : "5340",
  Client_Snapshot: "93",
  Mark_Sales: "",
  Portfolio: "",
  Portfolio_DataInfo: environment === PrdSsoEnvKey ? "6491" : "21235",
  Portfolio_DealExport: environment === PrdSsoEnvKey ? "9753" : "34969",
};

let env = "";
const AS_OF_DATE = "16";
if (AS_OF_DATE.lastIndexOf("%#") !== -1) {
  env = "16";
} else {
  env = AS_OF_DATE;
}

export const FilterIdentifier = {
  asOfDate: env,
  client_account_picker: environment === PrdSsoEnvKey ? "43" : "579",
  client_grpcomctryname: "512",
  client_grptypl2name: "513",
  client_selector: "5",
  fpv_bl: environment === PrdSsoEnvKey ? "66" : "596",
  fpv_bumnemo: "511",
  fpv_sbl: environment === PrdSsoEnvKey ? "67" : "597",
  fpv_ssbl: environment === PrdSsoEnvKey ? "68" : "598",
};

export const FilterUserSelection = {
  asOfDate: "value",
  client_grpcomctryname: "",
  client_grptypl2name: "",
  client_selector: "selectedIds",
  fpv_bls: "fpv_",
  fpv_bumnemo: "",
};
